module.exports = __webpack_public_path__ + "media/images/marketing/focus1-5403796ef9e8e0c0d1e1843831254f553341e7158049ee210219d364638a4708.jpg";